import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button, CheckBox, DateBox, SelectBox, Validator, ValidationGroup, Popover } from "devextreme-react";
import { setHideShowWizard, setBlocking, setConfigShedulerWizard, setStepWizard, doGetConfigurations, doGetCenterConfiguration, doGetFeriadosAdmin, resetBlockingState } from "../actions";
import moment from "moment";
import helper from "../../../../../../helpers/validaciones";
import RangeHoursWeek from "../../../../../Shared/rangeHours";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import constants from "../../../../../../helpers/constants";
import TextField from "../../../../../Shared/fields/TextField";

const moduleTimeList = [15, 30, 45, 60];

class formConfigApertura extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      helpPopover: false,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isPopupWizardOpen && !prevProps.isPopupWizardOpen) {
      this.props.dispatch(doGetFeriadosAdmin(this.props.centerId));
      this.props.dispatch(doGetCenterConfiguration(this.props.centerId));
    }
  }

  handleClose = () => {
    this.props.dispatch(setHideShowWizard(false));
    this.props.dispatch(resetBlockingState(this.props.centerId));
  }

  HandleBlockAll = (e) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.BlockAll = e.value
    this.props.dispatch(setBlocking(newBlocking));
  }

  concatDateAndTime = (date, time) => {
    if(!date) return null;
    const soloFecha = moment(new Date(date), "DD-MM-YYYY").format("DD-MM-YYYY");
    const soloHora = moment(time, "HH:mm").format("HH:mm");
    const fechaHora = `${soloFecha} ${soloHora}`;
    return new Date(moment(fechaHora, "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm"));
  }

  handleChangeDesde = (e) => {
    const newBlocking = { ...this.props.blocking };
    if (e.value !== null) {
      const start = this.concatDateAndTime(e.value, "00:00");
      newBlocking.startDate = start;
      newBlocking.pagerStartDate = start;
    } else {
      newBlocking.startDate = null;
      if (newBlocking.endDate) {
        newBlocking.endDate = null;
      }
    }
    this.props.dispatch(setBlocking(newBlocking));
  }
  handleChangeHasta = (e) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.endDate = this.concatDateAndTime(e.value, "23:30");
    this.props.dispatch(setBlocking(newBlocking));
  }
  handleChangeWorkDay = (data) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.startWorkDay = data.value.from;
    newBlocking.endWorkDay = data.value.to;
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    this.props.dispatch(setBlocking(newBlocking));
  }
  handleChangeSatWorkDay = (data) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.satWorkstart = data.value.from;
    newBlocking.satWorkEnd = data.value.to;
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    this.props.dispatch(setBlocking(newBlocking));
  }
  handleChangeSunWorkDay = (data) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.sunWorkStart = data.value.from;
    newBlocking.sunWorkEnd = data.value.to;
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    this.props.dispatch(setBlocking(newBlocking));
  }

  handleChangModuleTime = (e) => {
    const blocking = { ...this.props.blocking };
    blocking.moduleTime = e.value;
    if (blocking.IdConfig > 0) {
      blocking.isNewConfig = true;
    }
    this.props.dispatch(setBlocking(blocking));
  }
  handleChangeConfiguration = (e) => {
    // seteo los valores que posee la configuracion
    const newBlocking = { ...this.props.blocking };
    if (e.value !== 0) {
      this.props.dispatch(doGetConfigurations(newBlocking, e.value));
    } else {
      this.props.dispatch(resetBlockingState(this.props.centerId));
    }
  }

  createPriority = (workDays) => {
    const priorityData = [];
    workDays.forEach((item) => {
      // Configuracion de la matriz
      const pivot = helper.getDaysIndex(item.day);
      priorityData.push({
        text: helper.capitalizeFirstLetter(pivot.name),
        id: pivot.index,
        order: pivot.order,
      });
    });
    return priorityData.sort((a, b) => a.order - b.order);
  }
  createQuoteMatrix = (workDays, newBlocking) => {
    const data = [];
    workDays.forEach((item) => {
      let configStart;
      let configEnd;
      switch (item.day) {
        case "sabado": {
          configStart = moment("00:00", "HH:mm").format("HH:mm");
          configEnd = moment("23:30", "HH:mm").format("HH:mm");
          break;
        }
        case "domingo": {
          configStart = moment("00:00", "HH:mm").format("HH:mm");
          configEnd = moment("23:30", "HH:mm").format("HH:mm");
          break;
        }
        default:
          configStart = moment("00:00", "HH:mm").format("HH:mm");
          configEnd = moment("23:30", "HH:mm").format("HH:mm");
          break;
      }
      // ciclo para crear la matriz para una bloqueo con nueva configuracion
      let start = this.concatDateAndTime(new Date(), configStart);
      const end = this.concatDateAndTime(new Date(), configEnd);
      while (end > start) {
        const NewStartDate = start;
        start = new Date(start.getTime() + (parseInt(30, 10) * 60 * 1000));
        const s = moment(NewStartDate);
        const e = moment(start);
        data.push({
          day: item.order || (item.index === 0 ? 7 : item.index),
          startDate: NewStartDate,
          endDate: start,
          startDateInt: NewStartDate.setHours(s.hour(), s.minutes(), 0, 0),
          endDateInt: start.setHours(e.hour(), e.minutes(), 0, 0),
          Quotas: this.props.listQuotes,
        });
      }
    });
    return data;
  }

  enumerateDaysBetweenDates = (data) => {
      var dates = [];
      var weeks = []
      var currDate = moment(data.startDate).startOf('day');
      var lastDate = moment(data.endDate).startOf('day');

      while(currDate.diff(lastDate) < 0) {
        let pivot = helper.getDaysByOrder(currDate.format("E"))
        let _obj = {
          date: currDate.clone().toDate(),
          dayWeek: {
            day: pivot.name,
            id: pivot.index,
            order: pivot.order,
          }
        }
        dates.push(_obj);
        if(pivot.index === 0){
          weeks.push(dates)
          dates = [];
        }
        currDate.add(1, 'days')
      }
      if(dates.length > 0){
        weeks.push(dates)
      }
      return weeks;
  };

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid || true) {
      /*const newBlocking = { ...this.props.blocking };
      let _datesArr = this.enumerateDaysBetweenDates(newBlocking)
      const workDays = _datesArr[newBlocking.dataPage].map(e => e.dayWeek);//indicar posicion de la matriz
      if (newBlocking.oldData != null) newBlocking.data = newBlocking.oldData;
      let data = [];
      const priorityData = this.createPriority(workDays);

      if (newBlocking.IdConfig === 0) {
        newBlocking.Ciel = this.props.centerConfig.listCiel.map((i) => i.id);
        newBlocking.Exams = this.props.centerConfig.listExams.map((i) => i.id);
        newBlocking.ExamPools = this.props.centerConfig.listExamPools.map((i) => i.id);
        // Generar semana tipo con valores en cuota 0
        data = [...this.createQuoteMatrix(workDays, newBlocking)];
      }

      if (newBlocking.IdConfig > 0) {
        // ciclo para crear la matriz para una nueva bloqueo desde una configuracion historica
        if (newBlocking.isNewConfig !== true) {
          const loopConfig = [...newBlocking.data];
          loopConfig.forEach((conf) => {
            const s = moment(this.concatDateAndTime(new Date(), conf.StartTime));
            const e = moment(this.concatDateAndTime(new Date(), conf.EndTime));
            data.push({
              day: conf.Day === 0 ? 7 : conf.Day,
              startDate: this.concatDateAndTime(new Date(), conf.StartTime),
              endDate: this.concatDateAndTime(new Date(), conf.EndTime),
              startDateInt: this.concatDateAndTime(new Date(), conf.StartTime).setHours(s.hour(), s.minutes(), 0, 0),
              endDateInt: this.concatDateAndTime(new Date(), conf.EndTime).setHours(e.hour(), e.minutes(), 0, 0),
              Quotas: conf.Quotas,
            });
          });
        } else {
          data = [...this.createQuoteMatrix(workDays, newBlocking)];
        }
      }
      if (newBlocking.data && newBlocking.data.length) {
        newBlocking.oldData = [...newBlocking.data];
      }
      newBlocking.data = [...data];
      const momentsMax = data.map((d) => moment(d.endDate));
      const momentsMin = data.map((d) => moment(d.startDate));
      const config = {
        startDayHour: this.getTimeAsFloat(momentsMin, false),
        endDayHour: this.getTimeAsFloat(momentsMax, true),
        cellDuration: parseInt(30, 10),
      };
      newBlocking.priorityData = priorityData;
      this.props.dispatch(setConfigShedulerWizard(config));
      this.props.dispatch(setBlocking(newBlocking));*/
      this.props.dispatch(setStepWizard({
        stepOne: false,
        stepTwo: true,
        stepThree: false,
        stepSuccess: false,
      }));
    }
  }

  getTimeAsFloat = (time, isMax) => {
    let totalHour = isMax ? parseInt(moment.max(time).format("HH")) : parseInt(moment.min(time).format("HH"));
    const minutes = isMax ? parseInt(moment.max(time).format("mm")) : parseInt(moment.min(time).format("mm"));

    if (minutes === 15) { totalHour += 0.25; }
    if (minutes === 30) { totalHour += 0.5; }
    if (minutes === 45) { totalHour += 0.75; }
    return totalHour;
  }

  shouldDisableCalendarDay = (data) => {
    const day = new Date(data.date).getDay();
    return this.props.blocking.workDays.findIndex((i) => i.index === day) === -1;
  }

  renderJornadaTrabajo = (item, index) => {
    let checked = false;
    const newBlocking = { ...this.props.blocking };
    if (newBlocking.workDays && newBlocking.workDays.length > 0) {
      checked = newBlocking.workDays.find((d) => d.day.toLowerCase() === item.day.toLowerCase()) !== undefined;
    }

    return (

      <div key={index + item.day} className="grid-jornada-laboral-item">
        <CheckBox
          key={index + item.day}
          text={helper.capitalizeFirstLetter(item.day)}
          onValueChanged={(check) => this.HandleChangeChoseDays(check, item, index)}
          value={checked}
        >
          <Validator
            validationRules={[{
              type: "custom",
              validationCallback: () => this.props.blocking.workDays && this.props.blocking.workDays.length !== 0,
              message: "Debe seleccionar al menos un día",
            }]}
          />
        </CheckBox>
      </div>

    );
  }



  handleChangeName = (e) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.NameBlocking = e.value;
    this.props.dispatch(setBlocking(newBlocking));
  }

  handleChangeReasonBlock = (e) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.BlockingReasonId = e.value;
    this.props.dispatch(setBlocking(newBlocking));
  }

  handleChangeComment = (e) => {
    const newBlocking = { ...this.props.blocking };
    newBlocking.comment = e.value;
    this.props.dispatch(setBlocking(newBlocking));
  }

  render() {
    const {
      blocking,
      centerConfig,
    } = this.props;

    return (
      <React.Fragment>
        {blocking.IdCentro !== null && (
          <React.Fragment>
            {this.props.isModalWizardLoading && <LoadingOverlay />}
            <ValidationGroup>
              <div className="row">
                <div className="col-12" style={{ marginTop: 10 }}>
                  <TextField
                    id="nombreBloqueo"
                    maxLength={80}
                    label="Nombre del bloqueo"
                    value={this.props.blocking.NameBlocking}
                    onChange={this.handleChangeName}
                    //value={this.props.dataSolicitudAgendaSel.centroCostos ? this.props.dataSolicitudAgendaSel.centroCostos : ""}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ marginTop: 10 }}>
                  <CheckBox
                    id={"checkBlock"}
                    text={"Bloquear todos los cupos del periodo seleccionado"}
                    onValueChanged={this.HandleBlockAll}
                    defaultValue={this.props.blocking.BlockAll}
                  />
                  <Button
                    id="link4"
                    icon="help"
                    stylingMode="text"
                    onClick={(e) => this.setState({helpPopover: true})}
                  />
                  <Popover
                    target={'#link4'}
                    position={'top'}
                    width={300}
                    visible={this.state.helpPopover}
                    onHiding={() => this.setState({helpPopover: false})}
                  >
                    Se bloquearán todos los cupos independiente de su tipo.
                  </Popover>

                </div>
              </div>
              <div className="row">
                <div className="col-6 field-newDenuncia">
                  <h3><p>Fecha Inicio</p></h3>
                  <DateBox
                    id="startDate"
                    type="date"
                    width={"100%"}
                    placeholder="Fecha Inicio"
                    displayFormat="dd-MM-yyyy"
                    showClearButton
                    disabledDates={this.props.feriadosAdministrativos}
                    onValueChanged={this.handleChangeDesde}
                    defaultValue={new Date()}
                    min={new Date()}
                    max={blocking.endDate ? blocking.endDate : null}
                    value={blocking.startDate}
                    validationError={{ message: "Fecha indicada es mayor a la fecha final" }}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]
                      }
                    />
                  </DateBox>

                </div>
                <div className="col-6 field-newDenuncia">
                  <h3><p>Fecha Fin</p></h3>
                  <DateBox
                    id={"endDate"}
                    type="date"
                    width={"100%"}
                    placeholder="Fecha Fin"
                    disabledDates={this.props.feriadosAdministrativos}
                    displayFormat="dd-MM-yyyy"
                    showClearButton
                    defaultValue={new Date()}
                    min={blocking.startDate ? blocking.startDate : new Date()}
                    max="2100-01-01"
                    onValueChanged={this.handleChangeHasta}
                    value={blocking.endDate}
                    validationError={{ message: "Fecha indicada es menor a la fecha inicial" }}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]}
                    />
                  </DateBox>
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ marginTop: 10 }}>
                  <h3><p>Razón del bloqueo</p></h3>
                  <SelectBox
                    Id="BlockingReasonId"
                    searchEnabled
                    defaultValue={blocking.BlockingReasonId}
                    dataSource={this.props.blockReasonList}
                    displayExpr="Description"
                    valueExpr="Id"
                    onValueChanged={this.handleChangeReasonBlock}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]}
                    />
                  </SelectBox>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <TextField
                    id="comment"
                    maxLength={80}
                    label="Comentario"
                    onValueChanged={this.handleChangeComment}
                    valueChangeEvent="focusout"
                    value={blocking.comment}
                  />
                </div>
              </div>
              <div className="button-row">
                <div>
                  <Button
                    onClick={this.handleClose}
                    text="Cancelar"
                  />
                </div>
                <div>
                  <Button
                    onClick={this.handleNext}
                    type="success"
                    text="Siguiente"
                    disabled={blocking.NameBlocking &&
                      blocking.startDate &&
                      blocking.endDate &&
                      blocking.BlockingReasonId ? false : true}
                  />
                </div>
              </div>
            </ValidationGroup>
          </React.Fragment>
        )}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  blocking: state.bloqueosSel.blocking,
  configList: state.bloqueosSel.configList,
  centrosList: state.bloqueosSel.centrosList,
  listQuotes: state.bloqueosSel.listQuotes,
  steps: state.bloqueosSel.steps,
  isBackStep: state.bloqueosSel.isBackStep,
  centerConfig: state.bloqueosSel.centerConfig,
  isPopupWizardOpen: state.bloqueosSel.isPopupWizardOpen,
  centerId: state.bloqueosSel.centerId,
  isModalWizardLoading: state.bloqueosSel.isModalWizardLoading,
  feriadosAdministrativos: state.bloqueosSel.feriadosAdministrativos,
  blockReasonList: state.bloqueosSel.blockReasonList
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(formConfigApertura);
